// Static catalog - Phase 1.
//
// THREE PUBLIC EXPORTS:
//   - OFFERING_CATEGORIES  → high-level offerings on the home Category Explorer
//                            (includes Corporate + Leadership which have their own pages)
//   - COURSE_CATEGORIES    → catalog filter list used on the /courses page
//                            (only the 6 catalog buckets)
//   - COURSES              → only catalog courses (no leadership, no corporate variants)
//
// Leadership programs live in `src/data/leadership.js`.
// Pricing is uniform ($699) per current product decision ,  easy to vary later.

export const OFFERING_CATEGORIES = [
  {
    id: "sap",
    title: "SAP",
    short: "Structured SAP learning paths for consultants, freshers, and enterprise teams.",
    longCopy:
      "Build practical SAP skills through structured training paths designed for consultants, freshers, working professionals, and enterprise teams. Programs span core modules, S/4HANA, SAP Public Cloud, and SAP AI tracks.",
    audience: ["Consultants", "Freshers", "Working Professionals", "Implementation Teams"],
    topics: ["SAP S/4HANA", "SAP Public Cloud", "SAP AI & Joule", "End-to-end workflows"],
    cta: "Explore SAP Programs",
    link: "/courses?category=sap",
  },
  {
    id: "workday",
    title: "Workday ",
    short: "Workday HCM, Integrations, and Reporting.",
    longCopy:
      "Understand Workday HCM, Integrations, reporting, and real-world implementation workflows. Designed for consultants, support teams, and lateral hires moving into Workday roles.",
    audience: ["HCM Consultants", "Integration Engineers", "Implementation Teams", "Support Analysts"],
    topics: ["Workday HCM", "Integrations (PECI, EIB, Studio)", "Reporting", "Implementation Workflows"],
    cta: "Explore Workday Tracks",
    link: "/courses?category=workday",
  },
  {
    id: "ai",
    title: "AI",
    short: "Practical AI for everyday work ,  Claude, agentic systems, and professional workflows.",
    longCopy:
      "Learn practical AI tools and patterns for modern work ,  Claude, agentic AI, and AI workflows tuned for professionals who work with documents, data, and meetings.",
    audience: ["Knowledge Workers", "Analysts", "Managers", "Operations Teams"],
    topics: ["Claude", "Agentic AI", "AI for Professionals", "AI Productivity"],
    cta: "See AI Programs",
    link: "/courses?category=ai",
  },
  // {
  //   id: "microsoft",
  //   title: "Microsoft",
  //   short: "Practical Microsoft Copilot training for Microsoft 365 power users.",
  //   longCopy:
  //     "Use Microsoft Copilot across Word, Excel, Outlook, and Teams to accelerate business work ,  designed for professionals already in the Microsoft 365 ecosystem.",
  //   audience: ["M365 Users", "Knowledge Workers", "Managers"],
  //   topics: ["Copilot for Excel", "Copilot for Outlook", "Copilot for Teams", "Productivity workflows"],
  //   cta: "Browse Microsoft Programs",
  //   link: "/courses?category=microsoft",
  // },
  // {
  //   id: "corporate",
  //   title: "Corporate Training",
  //   short: "Customized IT training programs built around your team's business goals.",
  //   longCopy:
  //     "Customized training programs for organizations that want to upskill teams at scale ,  across SAP, Workday, AI, cloud, and productivity platforms.",
  //   audience: ["HR & L&D", "CIOs", "Business Heads", "Implementation Partners"],
  //   topics: ["Custom SAP/Workday tracks", "AI adoption", "Onboarding for new hires", "Productivity rollouts"],
  //   cta: "Plan Corporate Training",
  //   link: "/corporate",
  // },
  {
    id: "ai_leaders",
    title: "AI for Leaders",
    short: "Executive learning for AI, digital transformation, and business impact.",
    longCopy:
      "Executive-focused learning programs designed for leaders who want to understand AI, digital transformation, and business impact ,  without getting lost in implementation detail.",
    audience: ["VPs & Directors", "Founders", "Department Heads"],
    topics: ["AI for Leaders", "Digital Strategy", "Change Management", "Tech-business alignment"],
    cta: "Explore Leadership Programs",
    link: "/leadership",
  },
  {
  id: "bundles",
  title: "Bundles (Video Courses)",
  short: "Comprehensive learning paths combining multiple technologies and certifications.",
  longCopy:
    "Accelerated career-focused learning paths that combine multiple courses into a structured program. Master end-to-end skills across SAP, Workday, AI, Microsoft, and enterprise technologies through curated bundle programs.",
  audience: [
    "Career Switchers",
    "IT Professionals",
    "Enterprise Teams"
  ],
  topics: [
    "SAP Gold Bundle",
    "Workday Gold Bundle",
    "SAP Public Cloud Bundle",
    "SAP AI Gold Bundle"
  ],
  cta: "Explore Bundle Programs",
  link: "/courses?category=bundles",
},
];

// Catalog filter list ,  these are the buckets the /courses page filters by.
export const COURSE_CATEGORIES = [
  { id: "sap", title: "SAP" },
  { id: "workday", title: "Workday" },
  { id: "ai", title: "AI" },
  // No live Microsoft courses yet -- uncomment when there are.
  // { id: "microsoft", title: "Microsoft" },
  { id: "ai_leaders", title: "AI for Leaders" },
  { id: "bundles", title: "Bundles (Video Courses)" },
];


// Helper to build a baseline curriculum block. Keeps the data file readable.
const c = (price = "$699") => ({ price, currency: "USD" });

export const COURSES = [
  // -------- SAP (modules + SAP AI tracks live here per product decision) --------
  // {
  //   title: "SAP AI for MM Consultants",
  //   slug: "sap-ai-for-mm",
  //   category: "sap",
  //   description:
  //     "Apply AI inside SAP Materials Management workflows ,  automation, anomaly detection, and intelligent procurement scenarios.",
  //   longDescription: "This program walks consultants and procurement leads through practical applications of AI inside SAP MM. You'll see how automation, prediction, and intelligent agents reshape day-to-day",
  //   idealFor: "MM Consultants, Procurement Leads",
  //   format: ["Live"],
  //   level: "Intermediate",
  //   duration: "6 weeks",
  //   schedule: "Jan 13, 2026",
  //   tags: ["SAP", "AI"],
  //   cta: "Download Curriculum",
  //   seoTitle: "SAP AI for MM Consultants Training | ZaranTech",
  //   seoDescription: "Learn how AI is applied inside SAP MM with practical workflows for procurement and inventory.",
  //   keywords: ["SAP AI", "SAP MM", "AI for procurement"],
  //   featured: true,
  //   ...c(),
  //   curriculum: [
  //     "Introduction to AI in SAP Enterprise Systems",
  //     "The Generative AI Hub and LLMs for SAP MM",
  //     "SAP Joule - The AI Copilot in Materials Management",
  //     "Intelligent Procure-to-Pay Automation",
  //     "AI-Driven Inventory Management and Predictive Analytics",
  //     "End-to-End AI Project Implementation and Certification",
     
  //   ],
  //   curriculumModules: [
  //     {
  //       title: "Introduction to AI in SAP Enterprise Systems",
  //       content:
  //         "Where AI shows up across the SAP stack (S/4HANA, BTP, SuccessFactors)\nBusiness AI vs. traditional automation\nThe AI-enabled procurement mindset\nHow MM Consultants must evolve their toolkit",
  //       hands_on_activity: "Map five real MM pain points to concrete AI capabilities",
  //     },
  //     {
  //       title: "The Generative AI Hub and LLMs for SAP MM",
  //       content:
  //         "Introduction to SAP's Generative AI Hub\nGrounding LLMs on MM master data\nRAG patterns over vendor catalogs and contracts\nData privacy and compliance boundaries",
  //       hands_on_activity: "Prototype a vendor-Q&A assistant grounded on synthetic contract PDFs",
  //     },
  //     {
  //       title: "SAP Joule , The AI Copilot in Materials Management",
  //       content:
  //         "Joule capabilities inside MM transactions\nNatural-language purchase order lookups\nUsing Joule for goods-receipt anomaly triage\nJoule extensibility and prompt patterns",
  //       hands_on_activity: "Design 3 Joule prompts that shorten a real MM daily workflow",
  //     },
  //     {
  //       title: "Intelligent Procure-to-Pay Automation",
  //       content:
  //         "AI-driven requisition matching and PO creation\nSmart three-way match and exception routing\nAutomated invoice reconciliation\nAgent-based workflow orchestration",
  //       hands_on_activity: "Design an end-to-end AI-enabled P2P flow and identify STP wins",
  //     },
  //     {
  //       title: "AI-Driven Inventory Management and Predictive Analytics",
  //       content:
  //         "Demand forecasting with ML\nSafety-stock optimization\nAnomaly detection on movement types\nSupplier risk scoring",
  //       hands_on_activity: "Build a reorder-point recommender using sample plant data",
  //     },
  //     {
  //       title: "End-to-End AI Project Implementation and Certification",
  //       content:
  //         "Discovery to production rollout\nStakeholder management for AI in MM\nCapstone project scoping\nCertification exam readiness",
  //       hands_on_activity: "Present a capstone AI-in-MM roadmap for a target client scenario",
  //     },
  //   ],
  //   upsellCourses: ["sap-ai-masterclass", "sap-joule"],
  //   faqs: [
  //     {
  //       q: "Do I need prior AI or Python experience?",
  //       a: "No. The programme is designed for SAP MM consultants and procurement leads. We introduce every AI concept in the context of MM workflows, so functional experience is enough to keep pace.",
  //     },
  //     {
  //       q: "Which SAP versions are covered?",
  //       a: "The labs focus on S/4HANA and Generative AI Hub on BTP, with reference material for ECC users migrating to S/4. We refresh case studies each cohort as SAP ships new releases.",
  //     },
  //     {
  //       q: "Are the hands-on labs graded?",
  //       a: "Yes , each module culminates in a hands-on activity that your mentor reviews. You'll finish with a capstone artifact you can add to your portfolio and share with hiring teams.",
  //     },
  //     {
  //       q: "What if I miss a live session?",
  //       a: "Every session is recorded and posted within 12 hours. You also get access to the mentor Slack for asynchronous doubts and weekly office-hour drop-ins.",
  //     },
  //     {
  //       q: "Do you provide a completion certificate?",
  //       a: "Yes , a ZaranTech-issued completion certificate after you complete all modules and the capstone. It's a shareable digital credential recognised across our hiring-partner network.",
  //     },
  //   ],
  //   outcomes: [
  //     "Identify high-impact AI use cases inside MM",
  //     "Map AI patterns to specific MM transactions",
  //     "Run a structured rollout for an AI-enabled MM workflow",
  //   ],
  // },
  // {
  //   title: "SAP AI Masterclass",
  //   slug: "sap-ai-masterclass",
  //   category: "sap",
  //   description:
  //     "End-to-end masterclass covering AI, automation, and intelligent enterprise scenarios inside the SAP ecosystem.",
  //   longDescription: "A senior-level masterclass for consultants and architects designing the next decade of SAP. Covers the broader SAP AI stack , automation, Joule, agentic AI, and",
  //   idealFor: "SAP Professionals, Solution Architects",
  //   format: ["Live"],
  //   level: "Advanced",
  //   duration: "8 weeks",
  //   schedule: "Feb 10, 2026",
    
  // title: "SAP AI Masterclass",
  // slug: "sap-ai-masterclass",
  // category: "sap",

  // videoUrl: "https://youtu.be/LCpHHw5lRLo",
  // videoTitle: "SAP AI Masterclass Preview",
  // videoDescription: "Watch a 2-minute preview of the SAP AI Masterclass.",


  //   tags: ["SAP", "AI"],
  //   cta: "Download Curriculum",
  //   seoTitle: "SAP AI Masterclass | ZaranTech",
  //   seoDescription: "End-to-end SAP AI masterclass for consultants and architects.",
  //   keywords: ["SAP AI Masterclass", "Intelligent SAP"],
  //   ...c(),
  //   curriculum: [
  //     "AI Fundamentals and SAP Business AI Overview",
  //     "SAP Joule Copilot and User Experience AI",
  //     "SAP Generative AI and Custom Models",
  //     "SAP Agentic AI - AI Agents and Automation",
  //     "SAP AI Foundation & BTP Integration",
  //     "SAP Build Platform - Low-Code and Pro-Code AI ",
  //     "SAP Analytics Cloud and Predictive Planning",
  //     "AI in Key Functional Domains",
  //     "Intelligent Document Processing and Automation",
  //     "AI-Powered Integration and Event-Driven Architectures",
  //     "Future Trends, Governance, and Responsible AI",

  //   ],
  //   curriculumModules: [
  //     {
  //       title: "AI Fundamentals and SAP Business AI Overview",
  //       content:
  //         "The SAP Business AI stack: Joule, Foundation, Build\nModel families supported by SAP\nHow SAP embeds AI vs. how partners extend it\nSAP AI reference architecture",
  //       hands_on_activity: "Map an enterprise architecture and mark AI insertion points",
  //     },
  //     {
  //       title: "SAP Joule Copilot and User Experience AI",
  //       content:
  //         "Joule capabilities across LoBs\nEmbedded UX patterns\nJoule Studio and custom skills\nGovernance and prompt safety",
  //       hands_on_activity: "Build a custom Joule skill for a functional workflow",
  //     },
  //     {
  //       title: "SAP Generative AI and Custom Models",
  //       content:
  //         "Generative AI Hub in BTP\nModel selection and grounding\nRAG on SAP business data\nFine-tuning strategies",
  //       hands_on_activity: "Ground a model on sample SAP data and evaluate answer quality",
  //     },
  //     {
  //       title: "SAP Agentic AI , AI Agents and Automation",
  //       content:
  //         "Agents vs. copilots vs. workflows\nJoule agents and multi-step reasoning\nAgent handoffs across systems\nMonitoring agentic execution",
  //       hands_on_activity: "Design a multi-step agent for a real cross-module SAP workflow",
  //     },
  //     {
  //       title: "SAP AI Foundation & BTP Integration",
  //       content:
  //         "AI Core and AI Launchpad\nDeploying models on BTP\nInference APIs and quota management\nGovernance guardrails",
  //       hands_on_activity: "Deploy a small model to AI Core and consume it from a BTP app",
  //     },
  //     {
  //       title: "SAP Build Platform , Low-Code and Pro-Code AI",
  //       content:
  //         "Build Apps, Process Automation, Code\nWiring in AI services\nCustom UI over Joule\nProcess intelligence patterns",
  //       hands_on_activity: "Ship a low-code app that calls an AI service end-to-end",
  //     },
  //     {
  //       title: "SAP Analytics Cloud and Predictive Planning",
  //       content:
  //         "Smart Insights and Smart Predict\nPlanning with driver-based ML\nJust-Ask analytics\nStorytelling with AI",
  //       hands_on_activity: "Publish a Just-Ask story with a predictive scenario",
  //     },
  //     {
  //       title: "AI in Key Functional Domains",
  //       content:
  //         "AI in Finance: close-cycle acceleration\nAI in HR: talent intelligence\nAI in Sales: forecast + next-best-action\nAI in Supply Chain: exception handling",
  //       hands_on_activity: "Choose one domain and prototype an AI use case with sample data",
  //     },
  //     {
  //       title: "Intelligent Document Processing and Automation",
  //       content:
  //         "IDP with SAP AI services\nInvoice and PO capture\nExtraction quality and fallback to humans\nMetrics and continuous improvement",
  //       hands_on_activity: "Configure IDP for a sample vendor invoice pack",
  //     },
  //     {
  //       title: "AI-Powered Integration and Event-Driven Architectures",
  //       content:
  //         "Integration Suite + AI\nEvent Mesh for reactive workflows\nAI-augmented mapping and transformation\nOperational observability",
  //       hands_on_activity: "Wire an event-driven AI response into a mock S/4HANA flow",
  //     },
  //     {
  //       title: "Future Trends, Governance, and Responsible AI",
  //       content:
  //         "Enterprise AI risk framework\nEU AI Act and SAP posture\nMonitoring, audits, model cards\nRoadmap for architects",
  //       hands_on_activity: "Draft an AI governance policy for a mid-size enterprise",
  //     },
  //   ],
  //   upsellCourses: ["sap-ai-for-mm", "sap-joule"],
  //   faqs: [
  //     {
  //       q: "Who is this masterclass for?",
  //       a: "Senior SAP consultants, architects, and functional leads who want a strategic view of SAP's AI stack , Joule, Foundation, Build, Generative AI Hub , and how to lead AI-enabled programmes for their clients.",
  //     },
  //     {
  //       q: "How is this different from the SAP AI for MM Consultants course?",
  //       a: "The MM course is a role-focused deep-dive for procurement functional consultants. The Masterclass takes a horizontal view across every LoB (Finance, HR, Sales, Supply Chain) and adds a heavy architecture + governance layer.",
  //     },
  //     {
  //       q: "Is a working SAP AI Foundation tenant provided?",
  //       a: "Yes , cohort members get scoped access to a shared BTP + AI Foundation tenant during the programme, enough to complete every lab. Enterprise learners can bring their own tenants and we support that.",
  //     },
  //     {
  //       q: "Do you cover SAP Agentic AI?",
  //       a: "Absolutely , an entire module is dedicated to Joule agents, multi-step reasoning, and agent orchestration patterns across SAP and non-SAP systems.",
  //     },
  //     {
  //       q: "Will I be job-ready after this programme?",
  //       a: "The Masterclass is designed for practitioners who are already SAP-fluent. You'll leave with an AI programme playbook you can drive at your current employer or client engagement , not a from-zero job track.",
  //     },
  //   ],
  //   outcomes: [
  //     "Architect intelligent SAP solutions",
  //     "Lead client conversations on SAP AI",
  //     "Evaluate AI features in the SAP roadmap",
  //   ],
  // },
//   {
//     title: "SAP Joule",
//     slug: "sap-joule",
//     category: "sap",
//     description:
//       "Understand SAP Joule ,  what it is, how it works inside SAP, and how to use it in real business scenarios.",
//     longDescription: "A practical introduction to SAP Joule for functional consultants and power users. Covers what Joule is, where it shows up across SAP, and the real",
//     idealFor: "Functional Consultants, Power Users",
//     format: ["Live"],
//     level: "Beginner-Intermediate",
//     duration: "5 weeks",
//     schedule: "Jan 13, 2026",
//     videoUrl: "https://youtu.be/JRXLgvIu884",
// videoTitle: "Introduction to SAP Joule",
// videoDescription: "Course introduction and overview.",
//     tags: ["SAP"],
//     cta: "Download Curriculum",
//     seoTitle: "SAP Joule Training | ZaranTech",
//     seoDescription: "Practical SAP Joule training for functional consultants and power users.",
//     keywords: ["SAP Joule training", "SAP copilot"],
//     ...c(),
//     curriculum: [
//       "Introduction to SAP Joule & AI Concepts",
//       "Configuration & Integration",
//       "Business Use Cases with Joule",
//       "SAP Build + Joule App Development",
//       "Advanced Features & Final Wrap-up",
      
//     ],
//     outcomes: [
//       "Confidently use Joule in day-to-day SAP work",
//       "Identify Joule-fit workflows",
//       "Explain Joule's value to business stakeholders",
//     ],
//   },

  // -------- Workday (temporarily disabled -- all 3 courses commented out below) --------
//  {
//    title: "Workday HCM Mentorship",
//    slug: "workday-hcm-mentorship",
//    category: "workday",
//    description:
//      "Mentor-led Workday HCM track covering core HCM, business processes, security, and real implementation scenarios.",
//    longDescription: "A structured mentor-led path for aspiring Workday HCM consultants. You'll cover the full HCM domain , supervisory organizations, business processes, security, reporting, and configuration patterns",
//    idealFor: "Aspiring HCM Consultants",
//    format: ["Live"],
//    level: "Beginner-Intermediate",
//    duration: "10 weeks",
//    videoUrl: "https://youtu.be/esPoQO0MHUk",
//videoTitle: "Introduction to Workday HCM Training",
//videoDescription: "Course introduction and overview.",
//    schedule: "Jan 13, 2026",
//    tags: ["Workday"],
//    cta: "Download Curriculum",
//    seoTitle: "Workday HCM Mentorship | ZaranTech",
//    seoDescription: "Mentor-led Workday HCM program with practical scenarios.",
//    keywords: ["Workday HCM training", "Workday mentorship"],
//    featured: true,
//    ...c(),
//    curriculum: [
//      "Workday core architecture",
//      "Supervisory organizations",
//      "Staffing models",
//      "Business processes",
//      "Security framework",
//      "Compensation and benefits basics",
//      "Reporting fundamentals",
//      "Real-implementation walkthroughs",
//      "Capstone: configure a sample tenant",
//    ],
//    outcomes: [
//      "Confidently navigate Workday HCM",
//      "Design org structures and BPs",
//      "Speak the language of Workday projects",
//    ],
//  },
//  {
//    title: "Workday Integration",
//    slug: "workday-integration",
//    category: "workday",
//    description:
//      "Build real Workday integrations using EIB, Core Connectors, PECI, and Workday Studio with hands-on labs.",
//    longDescription: "Workday integration training for technical consultants. Covers EIB, Core Connectors, PECI, and Workday Studio , with real labs designed around the kind of integrations consultants",
//    idealFor: "Integration Engineers, Technical Consultants",
//    format: ["Live"],
//    level: "Intermediate-Advanced",
//    duration: "10 weeks",
//    schedule: "Feb 10, 2026",
//    tags: ["Workday"],
//    cta: "Download Curriculum",
//    seoTitle: "Workday Integration Training | ZaranTech",
//    seoDescription: "Workday integration training covering EIB, Studio, PECI and real labs.",
//    keywords: ["Workday integration", "Workday Studio"],
//    ...c(),
//    curriculum: [
//      "Workday integration framework",
//      "EIB inbound and outbound",
//      "Core Connectors",
//      "PECI patterns",
//      "Workday Studio fundamentals",
//      "Web Services & REST patterns",
//      "Error handling and monitoring",
//      "Capstone: build an end-to-end integration",
//    ],
//    outcomes: [
//      "Build EIB, CCx and Studio integrations",
//      "Diagnose integration failures",
//      "Design integration patterns for real clients",
//    ],
//  },
//  {
//    title:"Workday Advanced Reporting for HCM and Financials",
//    slug: "workday-reporting",
//    category: "workday",
//    description:
//      "Master Workday reporting ,  custom reports, calculated fields, dashboards, and analytics for HR teams.",
//    longDescription:
//      "A focused track on Workday reporting ,  from advanced custom reports to calculated fields, composite reporting, and analytics dashboards for HR teams.",
//    idealFor: "HR Analysts, Reporting Specialists",
//    format: ["Live"],
//    level: "Intermediate",
//    duration: "6 weeks",
//    videoUrl: "https://youtu.be/aohKf4ZfUWQ",
//videoTitle: "Introduction to Workday HCM Advanced Reporting",
//videoDescription: "Course introduction and overview.",
//    schedule: "Jan 13, 2026",
//    tags: ["Workday"],
//    cta: "Download Curriculum",
//    seoTitle: "Workday Reporting Training | ZaranTech",
//    seoDescription: "Workday reporting training covering calculated fields, dashboards, analytics.",
//    keywords: ["Workday reporting", "Workday analytics"],
//    ...c(),
// curriculum: [
//  "Workday HCM Advance Reporting",
//  "Workday Reporting Fundamentals",
//  "Data Sources & Business Objects (HCM)",
//  "Calculated Fields (HCM)",
//  "Report Security",
//  "Advanced & Matrix Reports (HCM)",
//  "Worklets & Dashboards",
//  "Workday Financial Advance Reporting",
//  "Financial Reporting Basics",
//  "Advanced Financial Reporting",
//  "Trending Reports",
//  "Composite Reports",
//  "Discovery Boards",
//],
//    outcomes: [
//      "Build advanced Workday reports",
//      "Use calculated fields effectively",
//      "Design reporting dashboards for HR",
//    ],
//  },
 

  // -------- Bundles --------
  {
    title: "SAP Gold Bundle",
    slug: "sap-gold-bundle",
    category: "bundles",
    link: "https://zarantech.teachable.com/p/sap-gold-bundle",
    description:
      "Bundled program combining SAP fundamentals, AI tracks, and Joule training ,  for professionals committing to a full SAP path.",
    longDescription:
      "A complete SAP journey in one bundle. Combines SAP fundamentals, SAP AI tracks, and SAP Joule training ,  designed for learners who want a full path instead of one-off courses.",
    idealFor: "Career Switchers, Working Professionals",
    format: ["Self-Paced"],
    level: "All Levels",
    // duration: "16 weeks",
    // schedule: "Jan 13, 2026",
    tags: ["SAP"],
    cta: "Request Syllabus",
    seoTitle: "SAP Gold Bundle | ZaranTech",
    seoDescription: "Bundle program covering SAP fundamentals, AI, and Joule.",
    keywords: ["SAP bundle", "Full SAP training"],
    ...c("$999"),
    includedCourses: ["sap-public-cloud", "sap-ai-masterclass", "sap-joule", "sap-ai-for-mm"],
    curriculum: [
      "Foundation phase ,  SAP landscape",
      "Module phase ,  Public Cloud + scope items",
      "AI phase ,  SAP AI Masterclass",
      "Joule phase ,  Joule fundamentals",
      "Specialization phase ,  SAP AI for MM",
      "Capstone ,  integrated scenario walkthrough",
    ],
    outcomes: [
      "Cover the full SAP + SAP AI landscape",
      "Speak fluently across modules and AI",
      "Land in implementation conversations confidently",
    ],
  },
  {
    title: "Workday Gold Bundle",
    slug: "workday-gold-bundle",
    category: "bundles",
    link: "https://zarantech.teachable.com/p/workday-bundle",
    description:
      "Complete Workday path ,  HCM mentorship, integrations, reporting, and release management in one bundled program.",
    longDescription:
      "An end-to-end Workday path bundling HCM mentorship, integrations, reporting, and release management. Built for learners who want a single committed path rather than piecemeal training.",
    idealFor: "Aspiring Workday Consultants",
    format: [ "Self-Paced"],
    level: "All Levels",
    // duration: "20 weeks",
    schedule: "Feb 10, 2026",
    tags: ["Workday"],
    cta: "Request Syllabus",
    seoTitle: "Workday Gold Bundle | ZaranTech",
    seoDescription: "End-to-end Workday training bundle: HCM, Integrations, Reporting, Release Management.",
    keywords: ["Workday bundle", "Full Workday training"],
    ...c("$999"),
    includedCourses: ["workday-hcm-mentorship", "workday-integration", "workday-reporting", "workday-release-management"],
    curriculum: [
      "Foundation ,  Workday HCM Mentorship",
      "Technical ,  Workday Integration",
      "Analytics ,  Workday Reporting",
      "Governance ,  Workday Release Management",
      "Capstone ,  integrated tenant walkthrough",
    ],
    outcomes: [
      "Cover the full Workday consultant skillset",
      "Move into HCM, integration, or analytics roles",
      "Speak across Workday disciplines",
    ],
  },
  {
    title: "SAP Public Cloud Bundle",
    slug: "sap-public-cloud-bundle",
    category: "bundles",
    link: "https://zarantech.teachable.com/p/sap-public-cloud-bundle",
    description:
      "Focused bundle for SAP S/4HANA Public Cloud implementations ,  fit-to-standard, configuration, and extensibility.",
    longDescription:
      "A focused bundle around SAP S/4HANA Public Cloud. Pairs the Public Cloud core training with extensibility and AI tracks tuned for cloud deployments.",
    idealFor: "Cloud Consultants, Architects",
    format: [ "Self-Paced"],
    level: "Intermediate-Advanced",
    // duration: "14 weeks",
    schedule: "Feb 10, 2026",
    tags: ["SAP"],
    cta: "Request Syllabus",
    seoTitle: "SAP Public Cloud Bundle | ZaranTech",
    seoDescription: "Bundle for SAP S/4HANA Public Cloud implementations and extensibility.",
    keywords: ["SAP Public Cloud bundle", "S/4HANA cloud bundle"],
    ...c("$799"),
    includedCourses: ["sap-public-cloud", "sap-ai-masterclass", "sap-joule"],
    curriculum: [
      "Foundation ,  Public Cloud essentials",
      "Configuration ,  scope items and FTS",
      "AI layer ,  SAP AI Masterclass",
      "Joule layer ,  Joule inside Public Cloud",
      "Capstone ,  cloud scenario walkthrough",
    ],
    outcomes: [
      "Run fit-to-standard workshops",
      "Configure scope items and extensibility",
      "Layer AI on top of Public Cloud",
    ],
  },
  {
    title: "SAP AI Gold Bundle",
    slug: "sap-ai-bundle",
    category: "bundles",
    link: "https://zarantech.teachable.com/p/sap-ai-gold-bundle",
    description:
      "Deep AI bundle ,  SAP AI Masterclass, Joule Deep Dive, Agentic AI, and SAP AI for MM in one comprehensive path.",
    longDescription:
      "A senior bundle dedicated to SAP AI ,  combining the Masterclass, Joule Deep Dive, Agentic AI, and SAP AI for MM. Designed for architects and innovation leads.",
    idealFor: "Architects, Innovation Leads, Senior Consultants",
    format: [ "Self-Paced"],
    level: "Advanced",
    // duration: "14 weeks",
    // schedule: "Feb 10, 2026",
    tags: ["AI, SAP"],
    cta: "Request Syllabus",
    seoTitle: "SAP AI Bundle | ZaranTech",
    seoDescription: "Senior bundle covering SAP AI Masterclass, Joule Deep Dive, Agentic AI, and AI for MM.",
    keywords: ["SAP AI bundle", "SAP Joule + agentic AI"],
    ...c("$799"),
    includedCourses: ["sap-ai-masterclass", "sap-joule-deep-dive", "sap-agentic-ai", "sap-ai-for-mm"],
    curriculum: [
      "Foundation ,  SAP AI Masterclass",
      "Joule depth ,  Joule Deep Dive",
      "Agentic depth ,  SAP Agentic AI",
      "Module application ,  SAP AI for MM",
      "Capstone ,  design an AI-enabled SAP scenario",
    ],
    outcomes: [
      "Architect AI-enabled SAP scenarios",
      "Govern agentic and Joule rollouts",
      "Lead innovation conversations on SAP AI",
    ],
  },
];

export const COURSE_TAGS = [
  "All",
  "SAP",
  "Workday",
  "AI",
  "Microsoft",
  "AI for Leaders",
];
